var _animateTransform, _animateTransform2, _animateTransform3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 174 174",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    }
  }, props), /*#__PURE__*/React.createElement("rect", {
    id: "loader",
    x: 0,
    y: 0,
    width: 173.239,
    height: 173.239,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "track",
    d: "M86.734,8.773c42.965,0 77.847,34.882 77.847,77.847c0,42.965 -34.882,77.847 -77.847,77.847c-42.965,0 -77.847,-34.882 -77.847,-77.847c0,-42.965 34.882,-77.847 77.847,-77.847Zm0,12.134c36.268,0 65.712,29.445 65.712,65.713c0,36.267 -29.444,65.712 -65.712,65.712c-36.267,0 -65.712,-29.445 -65.712,-65.712c0,-36.268 29.445,-65.713 65.712,-65.713Z",
    style: {
      fill: "#eff7ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "part3",
    d: "M35.653,27.894l7.963,9.154c-13.841,12.051 -22.594,29.797 -22.594,49.572c0,5.836 0.762,11.496 2.194,16.885l-11.73,3.118c-1.696,-6.384 -2.599,-13.089 -2.599,-20.003c0,-23.426 10.37,-44.45 26.766,-58.726Z",
    style: {
      fill: "#0fd8a7",
      fillOpacity: 0.2
    }
  }, _animateTransform || (_animateTransform = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "2s",
    values: "0 86.7 86.7; 160 86.7 86.7; 360 86.7 86.7",
    keyTimes: "0; 0.5; 1",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "part2",
    d: "M52.53,16.681l5.345,10.896c-21.756,10.664 -36.769,33.001 -36.852,58.826l-12.135,0c0.083,-30.605 17.865,-57.08 43.642,-69.722Z",
    style: {
      fill: "#0fd8a7",
      fillOpacity: 0.4
    }
  }, _animateTransform2 || (_animateTransform2 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "2s",
    values: "0 86.7 86.7; 182 86.7 86.7; 360 86.7 86.7",
    keyTimes: "0; 0.5; 1",
    repeatCount: "indefinite"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "part1",
    d: "M25.63,38.406c14.261,-18.045 36.34,-29.633 61.104,-29.633c5.618,0 11.097,0.596 16.379,1.729l-2.57,11.862c-4.453,-0.954 -9.073,-1.457 -13.809,-1.457c-20.908,0 -39.548,9.786 -51.586,25.023l-9.518,-7.524Z",
    style: {
      fill: "#0fd8a7"
    }
  }, _animateTransform3 || (_animateTransform3 = /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    dur: "2s",
    values: "0 86.7 86.7; 165 86.7 86.7; 360 86.7 86.7",
    keyTimes: "0; 0.5; 1",
    repeatCount: "indefinite"
  }))));
};
export default SvgLoading;